// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NcsE","comment":"styles_comment__2nAOo"};